import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { CasinoTable } from '@swf/core/types/CasinoGame';
import { closeWindow, getWindow, isRedirected } from '@swf/core/utils/casino';

import {
  TXTACL_Please_finish_or_close_the_ong_ELL,
  TXTACL_You_can_only_play_one_Free_Spi_ELL,
  TXTCLI_Cancel,
  TXTWCL_Free_Spin_Session_Already_Ongo_ELL,
  TXTWCL_Launch_Real_Money
} from './CasinoFSBError.messages.json';
import styles from './CasinoFSBError.scss';

const CasinoFSBError: React.FC = () => {
  const {
    state: { table }
  } = useLocation<{ table: CasinoTable }>();

  const {
    modal: { close },
    casino: { play }
  } = useDispatch<Dispatch>();

  const rootState = useSelector(select.getState);
  const isMobile = useSelector(select.device.isMobile);

  const handleClick = async () => {
    const { fsbId, ...rest } = table;
    play({ table: rest });
    close();
  };

  const handleClose = () => {
    const windowRef = getWindow({ table, rootState });
    if (windowRef) {
      if (!isRedirected(windowRef)) {
        closeWindow(windowRef, isMobile);
      } else {
        windowRef.focus();
      }
    }
    close();
  };

  return (
    <>
      <Header>
        <span>
          <Translation {...TXTWCL_Free_Spin_Session_Already_Ongo_ELL} />
        </span>
        <CloseButton />
      </Header>
      <Body className={styles.container}>
        <div className={styles.message}>
          <span>
            <Translation {...TXTACL_You_can_only_play_one_Free_Spi_ELL} />
            <br />
            <Translation {...TXTACL_Please_finish_or_close_the_ong_ELL} />
          </span>
        </div>
        <div className={styles.buttons}>
          <StarsButton
            variant="secondary"
            onClick={() => handleClose()}
            translation={TXTCLI_Cancel}
          />
          <StarsButton onClick={() => handleClick()} translation={TXTWCL_Launch_Real_Money} />
        </div>
      </Body>
    </>
  );
};

export default CasinoFSBError;
